import type { NormalizeOAS, OASOutput, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';
import { UserRole } from '../../types/Users';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/team/members', 'post'>;
type ResponseBody = OASOutput<O, '/api/team/members', 'post'>;

type Params = {
  newMemberEmail: string;
  newMemberRole: UserRole;
};

type Result = {
  id: number;
  isEmailAlreadyTaken: boolean;
};

export const inviteTeamMemberFactory = (apiClient: ApiClient) => {
  const inviteTeamMember = async (variables: Params) => {
    const requestBody = mapInputToRequestBody(variables);
    const response = await apiClient['/api/team/members'].post(requestBody);
    const responseBody = await response.json();

    return mapResponseToResult(responseBody);
  };

  const mapInputToRequestBody = (input: Params): RequestParams => {
    return {
      json: {
        newMemberEmail: input.newMemberEmail,
        newMemberRole: input.newMemberRole,
      },
    };
  };

  const mapResponseToResult = (response: ResponseBody): Result => {
    return {
      id: response.id,
      isEmailAlreadyTaken: response.isEmailAlreadyTaken,
    };
  };

  return inviteTeamMember;
};
